module.exports = __webpack_public_path__ + "img/factura_autorizar.8b523bf3.png";